import { TFunction } from '@translations/useTranslations'
import { formatDate, isValidDate, TimeStamp } from '@utils/Date'
import { NOTIFICATION_ACTIONS, parseNotificationText } from './utils'

const createActivityNotification = (t: TFunction) => {
  const NotificationComponent = (data: any) => {
    let translatedText = ''

    switch (data.action) {
      case NOTIFICATION_ACTIONS.PRODUCTION_PLANNING_DEADLINE_CHANGED:
        translatedText = t('commentLogs.deadLineOfMilestonePP')
        break
      case NOTIFICATION_ACTIONS.KEY_ACTIVITIES_DEADLINE_CHANGED:
        translatedText = t('commentLogs.deadLineOfMilestoneKA')
        break
      case NOTIFICATION_ACTIONS.MILESTONE_DEADLINE_CHANGED:
        translatedText = t('commentLogs.deadLineOfMilestone')
        break
      case NOTIFICATION_ACTIONS.PRODUCTION_PLANNING_REMINDER_CHANGED:
        translatedText = t('commentLogs.notifyMeDateOfMilestonePP')
        break
      case NOTIFICATION_ACTIONS.KEY_ACTIVITIES_REMINDER_CHANGED:
        translatedText = t('commentLogs.notifyMeDateOfMilestoneKA')
        break
      case NOTIFICATION_ACTIONS.PRODUCTION_PLANNING_EXECUTION_DATE_CHANGED:
        translatedText = t('commentLogs.milestoneExecDatePP')
        break
      case NOTIFICATION_ACTIONS.KEY_ACTIVITIES_EXECUTION_DATE_CHANGED:
        translatedText = t('commentLogs.milestoneExecDateKA')
        break
      default:
        translatedText = ''
    }

    return (
      <>
        {translatedText}{' '}
        <span className="font-semibold">{`"${parseNotificationText(
          data.milestone?.name,
        )}"`}</span>{' '}
        {isValidDate(data?.snapshot as TimeStamp)
          ? `${t('commentLogs.hasBeenChangedTo')} ${formatDate(
              data?.snapshot as TimeStamp,
            )}`
          : `${t('commentLogs.hasBeenRemoved')}`}
      </>
    )
  }
  return NotificationComponent
}

export const activityNotifications = (t: TFunction) => ({
  [NOTIFICATION_ACTIONS.MILESTONE_DEADLINE_CHANGED]:
    createActivityNotification(t),
  [NOTIFICATION_ACTIONS.PRODUCTION_PLANNING_DEADLINE_CHANGED]:
    createActivityNotification(t),
  [NOTIFICATION_ACTIONS.KEY_ACTIVITIES_DEADLINE_CHANGED]:
    createActivityNotification(t),
  [NOTIFICATION_ACTIONS.PRODUCTION_PLANNING_REMINDER_CHANGED]:
    createActivityNotification(t),
  [NOTIFICATION_ACTIONS.KEY_ACTIVITIES_REMINDER_CHANGED]:
    createActivityNotification(t),
  [NOTIFICATION_ACTIONS.PRODUCTION_PLANNING_EXECUTION_DATE_CHANGED]:
    createActivityNotification(t),
  [NOTIFICATION_ACTIONS.KEY_ACTIVITIES_EXECUTION_DATE_CHANGED]:
    createActivityNotification(t),
})
